<script setup lang="ts">
    import { ref, watch } from 'vue';
    import { getChannelLabel } from '@/js/services/api/interaction/consts';
    import { IInteraction } from '@/js/services/api/interaction/types';

    import { __ } from '@/js/stores/expressions';
    import { dateToString } from '@/js/utils/dateUtils';
    import InteractionTypeIcon from '../InteractionTypeIcon.vue';
    import EchoTooltip from '../../EchoTooltip.vue';

    defineProps<{ interaction: IInteraction }>();

    const externalIdEl = ref<HTMLElement | null>(null);
    const isExternalIdTruncated = ref(false);

    watch(
        externalIdEl,
        (el) => {
            if (el) isExternalIdTruncated.value = el.scrollWidth > el.clientWidth;
        },
        { flush: 'post' }
    );
</script>
<template>
    <div class="flex items-center gap-6 flex-wrap">
        <div class="flex items-center gap-3">
            <InteractionTypeIcon :channel-icon="interaction.channelIcon" size="lg" />
            <div>
                <h2 class="text-overline-sm text-gray-medium">
                    {{ __('agent') }}
                </h2>
                <p class="heading-sm">
                    {{ interaction.agentName }}
                </p>
            </div>
        </div>
        <div class="border-l border-gray-light pl-6">
            <h2 class="text-overline-sm text-gray-medium">
                {{ __('interaction-date') }}
            </h2>
            <p class="heading-sm whitespace-nowrap">
                {{ dateToString(new Date(interaction.startTime)) }}
            </p>
        </div>
        <div class="border-l border-gray-light pl-6 min-w-0">
            <EchoTooltip :label="interaction.externalId" :disabled="!isExternalIdTruncated">
                <h2 class="text-overline-sm text-gray-medium">
                    {{ __('interaction-id') }}
                </h2>
                <p ref="externalIdEl" class="heading-sm truncate max-w-56">
                    {{ interaction.externalId }}
                </p>
            </EchoTooltip>
        </div>
        <div class="border-l border-gray-light pl-6">
            <h2 class="text-overline-sm text-gray-medium">
                {{ __('interaction-media-type') }}
            </h2>
            <p class="heading-sm whitespace-nowrap">
                {{ getChannelLabel(interaction.channelName) }}
            </p>
        </div>
        <div class="border-l border-gray-light pl-6">
            <h2 class="text-overline-sm text-gray-medium">
                {{ __('interaction-agent-skill') }}
            </h2>
            <p class="heading-sm whitespace-nowrap">
                {{ interaction.skillName }}
            </p>
        </div>
    </div>
</template>
